export default __webpack_public_path__ + "static/media/lastframe.7b9ecf6f.webp";